import { Model } from 'dva'
import { AudioDemosService } from '../../Service'
import { IsObject } from '../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'
import { AudioDemo } from './types'

const AudioDemos: Model = {
  namespace: 'audioDemos',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let audioDemos = yield select((state: any) => state.audioDemos.list)
        if (!(audioDemos.length > 0 && useCache)) {
          audioDemos = yield call(AudioDemosService.audioDemosList, {})
          yield put({ type: 'modifyList', payload: audioDemos })
        }
        onSuccess(audioDemos)
      } catch (err: any) {
        FailureHandler('Error fetching audioDemos', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let audioDemo = yield select((state: any) =>
          state.audioDemos.list.find((audioDemo: AudioDemo) => audioDemo.id === id)
        )
        if (!audioDemo) {
          audioDemo = yield call(AudioDemosService.audioDemosRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: audioDemo })
        onSuccess(audioDemo)
      } catch (err) {
        FailureHandler('Could not find the audioDemo!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(AudioDemosService.audioDemosCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a audioDemo', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(AudioDemosService.audioDemosPartialUpdate, {
          id: id,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a audioDemo', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(AudioDemosService.audioDemosDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a audioDemo', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: AudioDemo) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: AudioDemo) => !action.payload.map((p: AudioDemo) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: AudioDemo) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetAudioDemos(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default AudioDemos
